import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

// `normalizza` decide in che forma il valore esce di qui: la distinta lo vuole minuscolo, perché
// i nomi del censimento sono tutti maiuscoli e sceglierne uno rimetterebbe in tabella una scrittura
// nuova per un gruppo che c'è già. Chi salva l'id del gruppo (i dati squadra) non la passa e vede i
// nomi come stanno nel censimento.
const AutocompleteGruppo = ({ value, onChange, gruppiScout = [], placeholder = 'Gruppo', disabled = false, style = {}, normalizza }) => {
  const canonico = (testo) => (normalizza ? normalizza(testo) : testo);
  const [isOpen, setIsOpen] = useState(false);
  const [filter, setFilter] = useState(value || '');
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    setFilter(value || '');
  }, [value]);

  const updatePosition = useCallback(() => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      updatePosition();
      window.addEventListener('scroll', updatePosition, true);
      window.addEventListener('resize', updatePosition);
      return () => {
        window.removeEventListener('scroll', updatePosition, true);
        window.removeEventListener('resize', updatePosition);
      };
    }
  }, [isOpen, updatePosition]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtered = gruppiScout.filter(g =>
    g.name.toLowerCase().includes(filter.toLowerCase())
  );

  const handleInputChange = (e) => {
    const testo = canonico(e.target.value);
    setFilter(testo);
    onChange(testo);
    setIsOpen(true);
  };

  const handleSelect = (gruppo) => {
    const testo = canonico(gruppo.name);
    setFilter(testo);
    onChange(testo, gruppo.id);
    setIsOpen(false);
  };

  const dropdown = isOpen && filtered.length > 0 && createPortal(
    <div style={{
      position: 'absolute',
      top: dropdownPos.top,
      left: dropdownPos.left,
      width: dropdownPos.width,
      maxHeight: '180px',
      overflowY: 'auto',
      backgroundColor: '#fff',
      border: '1px solid #e1e8ed',
      borderTop: 'none',
      borderRadius: '0 0 4px 4px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
      zIndex: 99999,
    }}>
      {filtered.map(g => (
        <div
          key={g.id}
          onMouseDown={() => handleSelect(g)}
          style={{
            padding: '6px 10px',
            cursor: 'pointer',
            fontSize: '0.85rem',
            borderBottom: '1px solid #f0f0f0',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f7ff'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
        >
          {canonico(g.name)}
        </div>
      ))}
    </div>,
    document.body
  );

  return (
    <div ref={wrapperRef}>
      <input
        ref={inputRef}
        type="text"
        value={filter}
        onChange={handleInputChange}
        onFocus={() => { updatePosition(); setIsOpen(true); }}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
      />
      {dropdown}
    </div>
  );
};

export default AutocompleteGruppo;
